/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Magnified_Download_ButtonInputs */

const en_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const fr_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telecharger`)
};

const de_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen`)
};

const it_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scaricamento`)
};

const ru_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать`)
};

const es_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar`)
};

const zh_cn2_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载`)
};

const ja_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード`)
};

const hi_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड करना`)
};

const pt_pt2_video_export_magnified_download_button = /** @type {(inputs: Video_Export_Magnified_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Video_Export_Magnified_Download_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_download_button = /** @type {((inputs?: Video_Export_Magnified_Download_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_Download_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_magnified_download_button(inputs)
	if (locale === "de") return de_video_export_magnified_download_button(inputs)
	if (locale === "it") return it_video_export_magnified_download_button(inputs)
	if (locale === "ru") return ru_video_export_magnified_download_button(inputs)
	if (locale === "es") return es_video_export_magnified_download_button(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_magnified_download_button(inputs)
	if (locale === "ja") return ja_video_export_magnified_download_button(inputs)
	if (locale === "hi") return hi_video_export_magnified_download_button(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_magnified_download_button(inputs)
	return en_video_export_magnified_download_button(inputs)
});